// Copyright (c) 2024 Lenovo. All right reserved.
// Confidential and Restricted
import Vue from 'vue'
import Vuex from 'vuex'
import { getRequest } from '@/api/api';
import { rolesKey,capitalizeFirstLetter} from '@/utils/utils';
import router from "@/router";

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // Initial state
        loginInfo: {}, // Login interface returns full data
        menuArr: [], // Menu data
        isHasRoutes: false, // Is there already routing data obtained from the server in the current routing data
        curPagePath: '', // The path of the last redirected page
        tabScroll: null, // The event triggered after pressing the tab key updates the distance that the scrollbar should scroll
        setCodeEnum: null, // Set pop-up code enumeration object
        rolesEnum: null, // Character Status Dictionary
        restartConditionEnum: null, // Upgrade condition enumeration dictionary
        loginStatus: false, // Store current memory data and retrieve status
        refreshFlag: false, // When using a browser to refresh a page, record the refresh status and replace the current route after refreshing
        isLoadingPermission: false, // 
    },
    getters: {
        roles(state) {
            let temRoles = ((state.loginInfo && state.loginInfo.roles) || []);
            return temRoles.length > 0 ? temRoles : [0];
        },
        curRoleKey(state) {
            let temRoles = ((state.loginInfo && state.loginInfo.roles) || []);
            return rolesKey[temRoles[0] || 2] || 'normal';
        },
        user(state) {
            if (state.loginInfo && state.loginInfo.user) {
                return state.loginInfo.user;
            } else {
                return {};
            }
        },
        // Is this your first login
        isFirstLogin(state) {
            let temUser = (state.loginInfo && state.loginInfo.user) ? state.loginInfo.user : { resetPasswordFlag: 0 };
            if(temUser.resetPasswordFlag === 1) {
                return true;
            } else {
                return false;
            }
        },
        // administrators
        isAdmin(state, getters) {
            return getters.roles.includes('super_admin');
        },
        // Regular account
        isNormal(state, getters) {
            return getters.roles.includes('normal');
        },
        // Button permission control
        permissions(state, getters) {
            let temPermissions = (state.loginInfo && state.loginInfo.permissions) || [];
            if (getters.roles.includes('super_admin') && !temPermissions.includes('*:*:*')) {
                temPermissions.push('*:*:*');
            }
            return temPermissions;
        },
        // Automatically convert the menu data obtained from the current interface into the required menu data object
        menuRoutes(state) {
            let temRoutePathObj = {};

            const routeItem = (obj) => {
                if (obj && obj.componentName)
                    temRoutePathObj['/' + obj.componentName] = { ...obj };
            }

            state.menuArr.forEach(i => {
                if (i.children && i.children.length > 0) {
                    i.children.forEach(j => routeItem(j))
                } else {
                    routeItem(i)
                }
            });

            return temRoutePathObj;
        },
        // Automatically convert the menu data obtained from the current interface into the required menu list
        menus(state) {
            let temMenus = JSON.parse(JSON.stringify(state.menuArr || []));

            const temMenuItem = (parent, child) => {
                let temObj = child || parent;
                parent.childRoutes = [...(parent.childRoutes || []), "/" + temObj.componentName]; // Determine whether to select by storing the icon of the current component name
            }

            temMenus.forEach(i => {
                let iconArr = [{ name: 'selIcon', img: '' }, { name: 'unSelIcon', img: 'un' }];

                iconArr.forEach(item => {
                    i[item.name] = `${process.env.VUE_APP_API_PUBLIC_IMG_URL}img/aside/${item.img}${i.icon}.png`;
                })

                if (i.children && i.children.length > 0) {
                    i.children.forEach(j => temMenuItem(i, j))
                } else {
                    temMenuItem(i);
                }
            })

            return temMenus;
        },
        // The homepage path of the user under the current role
        curRoleUserPath(state, getters) {
            let temMenuItem = getters.menus[0] || {};
            let temPath = (temMenuItem.children && temMenuItem.children && temMenuItem.children.length > 0) ? '/' + temMenuItem.children[0].componentName : temMenuItem.path;
            return temPath;
        },
    },
    mutations: {
        // Reset all data
        resetState(state) {
            state.menuArr = [];
            state.curPagePath = '';
            state.restartConditionEnum = null;
            state.setCodeEnum = null;
            state.rolesEnum = null;
            state.isLoginDialogShow = false;
            state.loginStatus = false;
        },
        // Update login information data
        updateLoginInfo(state, payload) {
            state.loginInfo = payload;
        },
        // Synchronize menu data changes
        updateMenuArr(state, payload) {
            state.menuArr = payload;
        },
        // Update whether there is routing data
        updateIsHasRoutes(state, payload) {
            state.isHasRoutes = payload;
        },
        // Update current reason address
        updateCurPagePath(state, payload) {
            state.curPagePath = payload;
        },
        // Update Settings Pop up
        updateSetCodeEnum(state, payload) {
            state.setCodeEnum = payload;
        },
        // Update role dictionary
        updateRolesEnum(state, payload) {
            state.rolesEnum = payload;
        },
        // Update and upgrade time dictionary
        updateRestartConditionEnum(state, payload) {
            state.restartConditionEnum = payload;
        },
        // Update password pop-up window
        updateIsLoginDialogShow(state, payload) {
            state.isLoginDialogShow = payload;
        },
        // Update the current memory data retrieval status for storage
        updateLoginStatus(state, payload) {
            state.loginStatus = payload;
        },
        // Update storage to see if the browser refreshes the page
        updateRefreshFlag(state, payload) {
            state.refreshFlag = payload;
        }
    },
    actions: {
        async isHasLoginData({ state, commit }, func) {
            if (state.loginStatus || state.isLoadingPermission) {
                if(func) func();
                //if (typeof func === 'function') func();
                return;
            }
            let menus;
            if (!state.loginStatus && !!!window.isPermissionFaild) {
                try
                {
                    //commit('setLoadingPermission', true); 
                    Vue.prototype.$loading(true);
                    const res = await getRequest('/system/auth/get-permission-info');
                    if(!!!res)
                    {
                        router.push({ path: '/login' });
                        return;
                    }
                    if(res.code == 401)
                    {
                        window.removeCookie("token");
                        router.push({ path: '/login' });
                        Vue.prototype.$loading(false);
                        return;                    
                    }
                    if(res.code == 502)
                    {
                        window.backendCode = "502"; // if  the server is string then the backend interface return 502 
                        Vue.prototype.$loading(false);
                    }
                    if (res.code === 200) {
                        
                        commit('updateLoginInfo', res.data);

                        menus = res.data.menus;
                        menus.forEach( (item)=>{
                            if(item.name == "显示器列表")
                            {
                                item.Ename = "Monitor List";
                            }
                     
                            else if(item.name == "更新包")
                            {
                                //item.Ename = "Installation Package List";
                                //item.Ename = "List of update packages";
                                item.Ename = "Update Package";
                            }
                            else if(item.name == "设置-配置文件")
                            {
                                item.Ename = "Settings - Profiles";
                            }
                            else if(item.name == "用户管理")
                            {
                                item.Ename = "User Management";
                            }
                            else if(item.name == "操作记录")
                            {
                                item.Ename = "Operation Records";
                            }
                        });
                        commit('updateMenuArr', JSON.parse(JSON.stringify(res.data.menus)));
                        await storeCache.getSetCodeEnum();
                        await storeCache.getRoleEnum();
                        await storeCache.getConditionEnum();
                        commit('updateLoginStatus', true);
                    }
                    else
                    {
                        window.isPermissionFaild = true;
                        /*
                        let href = window.location.href;
                        let pos = href.indexOf("#");
                        window.location.href = href.substring(0,pos)+"#/login";
                        */
                        if(this.$router)
                        {
                            window.redirect("/login");
                        }
                    }
                    Vue.prototype.$loading(false);
                    if(func) func();
                    //if (typeof func === 'function') func();
                }
                catch(e){
                    router.push({ path: '/login' });
                }
                finally{
                    //commit('setLoadingPermission', false); 
                    Vue.prototype.$loading(false);
                }

            }
        }
    }
})

/**
 * Retrieve the formatted option array
 * @param {*} optionObj Target object added to
 * @param {*} list Original option array
 * @param {*} callBack Special processing will pass in a new option object
 * @returns Return new option array
 */
export function addRadioList(optionObj, list, callBack) {
    optionObj.propertyObj = {};
    optionObj.radioArr = list.map(i => {
        if (callBack) { callBack(i) };
        let temVal = { ...i, label: i.name=='communication'?capitalizeFirstLetter(i.name):i.name, value: i.code };
        optionObj.propertyObj[i.code] = i;
        return temVal;
    });
}

/**
 * Add formatted new options for enum fields
 * @param {*} originEnum Total enumeration
 * @param {*} optionObj Configuration item object
 */
export function addOption(originEnum, optionObj) {
    originEnum.enumSetInitObj[optionObj.code] = JSON.parse(JSON.stringify(optionObj));
    let temData = originEnum.originSettingObj[optionObj.key];
    if(temData && (temData.length || temData.length === 0)) {
        temData.push(optionObj);
    } else {
        temData = { ...optionObj };
    }
}

/**
 *Set the variable names corresponding to different types of data in the pop-up window
 */
export const setCodeKey = {
    'radiogroup': 'radioCheckboxArr',
    'radiogroup-img': 'imgCheckboxArr',
    'slider': 'sliderArr',
    'slider-list-color': 'colorObj',
    'slider-stop': 'gamma',
    'switch': 'switchCheckboxArr',
    'tabs': 'tabCheckboxArr'
};

/**
 *Initialize Settings Pop up Full Configuration Data
 */
export const initSetEnum = {
    enumArr: [],
    enumObj: {},
    enumSetInitObj: {},
    enumTypeArr: {},
    enumTypeObj: {},
    originSettingObj: {
        imgCheckboxArr: [],
        radioCheckboxArr: [],
        gamma: {},
        color: { colorObj: {} },
        sliderArr: [],
        tabCheckboxArr: [],
        switchCheckboxArr: [],
    },
};

const storeCache = {
    async getSetCodeEnum() {
        let temSetCode = JSON.parse(JSON.stringify(initSetEnum)), temSetVal = null;
        if (store.state.setCodeEnum) {
            temSetCode = JSON.parse(JSON.stringify(store.state.setCodeEnum));
        } else {
            const res = await getRequest("/modelDisplay/modelDisplayDetail/getSettingDetailEnum")
            if (res && res.code === 200) {
                res.data.forEach(i => {
                    i = { ...i, funcCode: i.code, /** Backup of backend fields */ key: setCodeKey[i.type], propertyObj: {}, description: i.desc }
                    temSetVal = {
                        ...i,
                        selected: '',
                        checked: i.type.includes('slider') ? 0 : '',
                    };
                    switch (i.type) {
                        case 'radiogroup-img':
                            addRadioList(temSetVal, i.propertyList, temVal => {
                                let type = i.name || '', optionName = (temVal.name || '').replace(/\s+/g, '').toLowerCase();
                                try {
                                    temVal.selImg = require(`@/assets/img/${type + 'sel_' + optionName}.png`);
                                    temVal.unSelImg = require(`@/assets/img/${type + optionName}.png`);
                                } catch (error) {
                                    temVal.selImg = require(`@/assets/img/Frame.svg`);
                                    temVal.unSelImg = require(`@/assets/img/unFrame.svg`);
                                }
                            })
                        break;
                        case 'slider-stop':
                            temSetVal = {
                                ...temSetVal,
                                radioArr: i.propertyList,
                                radioObj: {},
                                max: Number(i.propertyList.slice(-1)[0].name || 4.0),
                                min: Number(i.propertyList[0].name || 1.6),
                                marks: {},
                                marksValue: {},
                                stepValue: {},
                            };
                            i.propertyList.forEach((j, jndex) => {
                                i.propertyObj[j.code] = j;
                                temSetVal.radioObj[j.code] = j;
                                temSetVal.marks[Number(j.name)] = j.name || (jndex * 0.2).toString();
                                temSetVal.marksValue[Number(j.name)] = j.code;
                                let temStepVal = 0, temJndex = jndex === (i.propertyList.length - 1) ? jndex - 1 : jndex;
                                temStepVal = i.propertyList[temJndex + 1].name * 100 - i.propertyList[temJndex].name * 100;
                                temSetVal.stepValue[Number(j.name)] = Number((temStepVal / 100).toFixed(1));
                            })
                            temSetVal.checked = temSetVal.marksValue[temSetVal.min];
                        break;
                        case 'slider-list-color':
                            temSetCode.enumSetInitObj[i.code] = {
                                code: i.code.slice(0, 4),
                                checked: 0,
                                funcCode: i.code,
                                key: setCodeKey[i.type]
                            };
                            temSetCode.originSettingObj.color.code = 'colorCode';
                            temSetCode.originSettingObj.color.selected = '';
                            temSetCode.originSettingObj.color.name = '颜色';
                            temSetCode.originSettingObj.color.description = i.desc;
                            temSetCode.originSettingObj.color.colorObj[i.code] = temSetCode.enumSetInitObj[i.code];
                        break;
                        case 'radiogroup':
                        case 'tabs':
                        case 'switch':
                            addRadioList(temSetVal, i.propertyList);
                        break;
                    }
                    addOption(temSetCode, temSetVal);
                    i.propertyObj = JSON.parse(JSON.stringify(temSetVal.propertyObj));
                    temSetCode.enumTypeArr[i.type] = [...(temSetCode.enumTypeArr[i.type] || []), i];
                    temSetCode.enumTypeObj[i.type] = { ...temSetCode.enumTypeObj[i.type], [i.code]: i };
                    temSetCode.enumArr.push(i);
                    temSetCode.enumObj[i.code] = { ...i };                    
                })
            }
            store.commit('updateSetCodeEnum', { ...(store.state.setCodeEnum || {}), ...temSetCode });
        }
        return temSetCode;
    },
    async getSettingObjNew(settingArr = [], isAll = false, isSelect, isInit = false) {
        let temSetCode = await this.getSetCodeEnum(), forEachArr = null, obj = {
            imgCheckboxArr: {},
            radioCheckboxArr: {},
            gamma: {},
            colorObj: {},
            sliderArr: {},
            tabCheckboxArr: {},
            switchCheckboxArr: {},
            isSelectedAllSetting: true, // Are all selected
        }, foreachObj = {}, temVal = null, temStr = '';

        if (isInit) {
            return JSON.parse(JSON.stringify(temSetCode.originSettingObj))
        }

        forEachArr = isAll ? temSetCode.enumArr : settingArr;
        
        let temSelect = (isSelect === true || isSelect === false) ? true : false; // By passing in fields, determine whether the current selection should be made
        let allSelected = [];

        settingArr.forEach(i => foreachObj[i.funcCode] = i);

        const disabledIDArr = window.configDisabledIDArr || [];
        forEachArr.forEach(i => {
            if(i && disabledIDArr.includes(i.funcCode)) return;
            temVal = JSON.parse(JSON.stringify(temSetCode.enumSetInitObj[i.funcCode]));
            temVal.selected = (foreachObj[i.funcCode] && foreachObj[i.funcCode].selectedFlag) ? temVal.code : ''; // Determine whether to select through backend data feedback
            allSelected.push(temVal.selected ? true : false);
            temVal.checked = foreachObj[i.funcCode] ? foreachObj[i.funcCode].funcValue : temVal.checked;
            temStr = (temVal.type || '') + ',' + (i.type || '');
            temVal.checked = !(temStr.includes('color') || temStr.includes('slider')) ? temVal.checked : Number(temVal.checked);
            if (foreachObj[i.funcCode] && foreachObj[i.funcCode].id) {
                temVal.id = foreachObj[i.funcCode].id;
            }
            obj[temVal.key][temVal.funcCode] = temVal;
        })

        obj.color = {
            code: '',
            selected: '',
            name: '颜色',
            description: '',
            type: 'sliderColor',
            colorObj: obj.colorObj
        }
        delete obj.colorObj;

        for (const key in obj.color.colorObj) {
            obj.color.code = 'colorCode';
            if (obj.color.colorObj[key].selected) {
                obj.color.selected = obj.color.code;
            }
            break;
        }

        allSelected.push(obj.color.selected ? true : false);
        obj.isSelectedAllSetting = (allSelected.filter(i => !i).length > 0) ? false : true;

        if (JSON.stringify(obj.gamma) !== '{}') {
            let temVal = null;
            for (const key in obj.gamma) {
                temVal = obj.gamma[key];
            }
            obj.gamma = temVal;
            obj.gamma.checked = Number((temVal.radioObj[temVal.checked] || temVal.radioArr[0]).name);
        }
        
        return obj;
    },
    async getRoleEnum() {
        let temRoles = { enumArr: [], enumObj: {} };
        if (store.state.rolesEnum) {
            temRoles = JSON.parse(JSON.stringify(store.state.rolesEnum));
        } else {
            const res = await getRequest("/system/user/getRoleEnum");
            if (res && res.code === 200) {
                temRoles.enumArr = res.data.map(i => {
                    if(i.name == "管理员")
                    {
                        i.name = "Admin";
                    }
                    else if(i.name == "普通用户")
                    {
                        i.name = "Common user";
                    }
                    temRoles.enumObj[i.code] = i;
                    return i;
                })
            } else {
                temRoles = { enumArr: [], enumObj: {} };
            }
            
            store.commit('updateRolesEnum', { ...(store.state.rolesEnum || {}), ...temRoles });
        }
        return temRoles;
    },
    async getConditionEnum() {
        let temConditionEnum = { enumArr: [], enumObj: {} };
        if (store.state.restartConditionEnum) {
            temConditionEnum = JSON.parse(JSON.stringify(store.state.restartConditionEnum));
        } else {
            const res = await getRequest("/modelDisplay/modelDisplayDetail/getUpdateConditions");
            if (res && res.code === 200) {
                temConditionEnum.enumArr = res.data.map(i => {
                    temConditionEnum.enumObj[i.code] = i;
                    return i;
                })
            }

            store.commit('updateRestartConditionEnum', { ...(store.state.restartConditionEnum || {}), ...temConditionEnum });
        }
        return temConditionEnum;
    },
}

export { storeCache }

/**
*Method
*Update data when refreshing the page
*/
//Set up monitoring

if (sessionStorage.getItem("state")) {
    store.replaceState(Object.assign(store.state, JSON.parse(sessionStorage.getItem("state"))));
    sessionStorage.setItem('state', '');
}

window.addEventListener('beforeunload', () => {
    store.commit('resetState');
    let temStoreState = { ...store.state };
    temStoreState.isLoginDialogShow = false;
    temStoreState.isHasRoutes = false;
    temStoreState.refreshFlag = true;
    sessionStorage.setItem('state', JSON.stringify(temStoreState));
})

export default store